import React from 'react';
import PropTypes from 'prop-types';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { getAQIRangeText } from 'routes/newslisting/layouts/config/AqiConfig';
import { cityNameMap, createSlug } from 'utils/common';
import { bindGa } from 'helpers/analytics';
// import { cityNameMap } from 'utils/common';
// import WithGeo from '../../helpers/ads/WithGeo';
import { convertToF } from './Util';
import s from './weather.scss';

class Weather extends React.Component {
  constructor(props) {
    super();
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      cityName: props.cityname,
      isWeatherInC:
        typeof props.isWeatherInC !== 'undefined' ? props.isWeatherInC : true,
      isToggleRequired: props.isToggleRequired,
    };
    this.weatherOnClick = this.weatherOnClick.bind(this);
  }
  toggleWeather = () => {
    this.setState({
      isWeatherInC: !this.state.isWeatherInC,
    });
  };
  @bindGa({})
  // eslint-disable-next-line class-methods-use-this
  weatherOnClick() {
    const {
      cityname,
      cityPostalId,
      gaCategory,
      cityAqiValue,
      // showAqiText,
    } = this.props;
    const currentCityName = createSlug(cityname, true);
    if (gaCategory && cityAqiValue) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'weather_cta',
        category: `${currentCityName}_weather_cta_click`,
        msid: cityPostalId,
      });
    } else if (gaCategory) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'weather_cta',
        category: gaCategory,
        msid: cityPostalId,
      });
    }
    window.open(
      `https://timesofindia.indiatimes.com/weather/${currentCityName}-weather-forecast-today/${cityPostalId}`,
    );
  }
  aqiOnClick() {
    const { cityname, cityPostalId } = this.props;
    const currentCityName = createSlug(cityname, true);
    if (currentCityName) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'aqi_cta',
        category: `${currentCityName}_aqi_cta_click`,
        msid: cityPostalId,
      });
    }
    window.open(
      `https://timesofindia.indiatimes.com/weather/${currentCityName}-aqi-level-air-quality-index-today/${cityPostalId}`,
    );
  }
  render() {
    const {
      colorTheme,
      addExtraClass,
      cityname,
      data,
      showWeather,
      cityAqiValue,
      showAqi,
      showAqiText,
    } = this.props;

    const showAqiTextValue = cityAqiValue && getAQIRangeText(cityAqiValue);
    const curTempInC = data.temp;
    const curTempInF = convertToF(data.temp);
    const iconCode = this.props.iconsMap[data.iconCode] || '';
    const { skyCover } = data;

    const theme = colorTheme ? s[colorTheme] : '';
    const weatherDetails = this.state;
    return (
      data && (
        <div className={`${showWeather ? s.cityWeatherWrap : ''}`}>
          <div
            className={`${showWeather ? s.cityWeather : 'weatherWidgetWrap'}`}
          >
            <div
              className={`${
                showAqiTextValue
                  ? `${s.weatherFlex} ${s.weatherWdt} `
                  : s.weatherWdt
              } ${theme}`}
              onClick={event => {
                this.weatherOnClick(event, weatherDetails);
              }}
              data-newga="NavBar-Header#Header-Weather"
            >
              {cityname &&
                !this.props.isWapView &&
                !this.props.hideCityName && (
                  <span className={s.cityName}>
                    {cityNameMap[cityname] || cityname}
                  </span>
                )}
              <span className={s.tempG}>
                <span className={`${s.icon}  ${iconCode}`} />
                <span className={s.temp}>
                  <span className={`${s.wdC} ${addExtraClass}`}>
                    <span>
                      {weatherDetails.isWeatherInC === true
                        ? curTempInC
                        : curTempInF}
                      &#xB0;
                    </span>
                    <span>
                      {weatherDetails.isWeatherInC === true ? 'C' : 'F'}
                    </span>
                  </span>
                </span>
              </span>
              {showWeather &&
                skyCover && <span className={s.skyCover}>{skyCover}</span>}
              {weatherDetails.isToggleRequired === 'YES' ? (
                <span className={s.optionshome}>
                  <button onClick={this.toggleWeather}>
                    °{weatherDetails.isWeatherInC === true ? 'F' : 'C'}
                  </button>
                  <a href="/weather.cms" target="_blank" className={s.arrow}>
                    »
                  </a>
                </span>
              ) : (
                <></>
              )}
            </div>
            {showAqi &&
              cityAqiValue && (
                <div
                  className={s.aqiWidgetWrap}
                  onClick={event => {
                    this.aqiOnClick(event, weatherDetails);
                  }}
                >
                  <div className={`${s.aqiWidget}`}>
                    <i className={s.aqiIcon} />
                    <strong>{cityAqiValue}</strong> <span>AQI</span>
                  </div>
                  {showAqiText &&
                    showAqiTextValue && (
                      <span className={s.aqiQuality}>{showAqiTextValue}</span>
                    )}
                </div>
              )}
          </div>
        </div>
      )
    );
  }
}

Weather.propTypes = {
  cityname: PropTypes.string.isRequired,
  data: PropTypes.shape({
    temp: PropTypes.number,
    iconCode: PropTypes.number,
  }).isRequired,
  iconsMap: PropTypes.shape({}).isRequired,
  isToggleRequired: PropTypes.string,
  isWapView: PropTypes.bool,
  isWeatherInC: PropTypes.bool,
  colorTheme: PropTypes.string,
  addExtraClass: PropTypes.string,
  hideCityName: PropTypes.bool,
};

Weather.defaultProps = {
  isToggleRequired: 'NO',
  isWapView: false,
  isWeatherInC: true,
  colorTheme: '',
  addExtraClass: '',
  hideCityName: false,
};

export default Weather;
